import { TabDatosGenerales } from "./TabDatosGenerales";
import { TabDatosContacto } from "./TabDatosContacto";
import { TabDatosSeleccion } from "./TabDatosSeleccion";
import { TabDelegacion } from "./TabDelegacion";

export const tabs = [
    {
        id: 1,
        name: 'Datos Generales',
        disabled: false,
        component: <TabDatosGenerales />,
    },
    {
        id: 2,
        name: 'Datos de Contacto',
        disabled: true,
        component: <TabDatosContacto />,
    },
    {
        id: 3,
        name: 'Delegación',
        disabled: false,
        component: <TabDelegacion />,
    },
    {
        id: 4,
        name: 'Datos Selección',
        disabled: true,
        component: <TabDatosSeleccion />,
    }
];